import React, { Fragment, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavBar } from 'app-components';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { IEX_STATE_CODES } from '@constants/configs/states';
import { useIntl } from 'react-intl';

export const useTopNavMenu = (userActiveRole, roleLabel, roleLabels, roles, role, endpoints, SETTINGS, stateCode) => {

    const [activeRoleLabel, setActiveRoleLabel] = useState(roleLabel);
    // useEffect to store roleLabel in sessionStorage and setActiveRoleLabel setter whenever it changes
    const intl = useIntl();
    useEffect(() => {
        if (roleLabel) {
            sessionStorage.setItem('userActiveRoleLabel', roleLabel);
            setActiveRoleLabel(roleLabel);
        }
    }, [roleLabel]);

    const handleChangeRole = (roleKey) => {
        sessionStorage.setItem('userActiveRoleLabel', roleLabels[roleKey]);
        sessionStorage.setItem('isInImpersonationMode', 'false');
        sessionStorage.setItem('impersonateHHID', '');
        sessionStorage.setItem('exitImpersonation', 'true');
        setActiveRoleLabel(roleLabels[roleKey]);
        window.location.href = endpoints.HEADER_ROLES_LINK.processReplacements({ encryptedRoleName: roles[roleKey] });
    };

    const isShowAccountSettings = stateCode === IEX_STATE_CODES.MN && role !== ALL_USER_ROLES.INDIVIDUAL;
    const sortedRoleLabels = Object.entries(roleLabels).sort(([, valueA], [, valueB]) => valueA.localeCompare(valueB));
    const selectedRole = Object.keys(roleLabels).find(key => roleLabels[key] === roleLabel);

    const TopNavMenuComponent = () => {
        return (
            <NavBar>
                <ConditionalRendering isTrue={isShowAccountSettings}>
                    <NavBar.Item>
                        <NavBar.Link id="account_settings" url={SETTINGS} labelId="label.account.settings" />
                    </NavBar.Item>
                </ConditionalRendering>
                <NavBar.Item>
                    <NavBar.Menu
                        id="rolesList"
                        iconName={selectedRole === role ? 'key' : undefined}
                        label={`${activeRoleLabel} ( Change`}
                    >
                        <NavBar.SubMenuItem id="my-role" labelId={'header.myRole'} />
                        {sortedRoleLabels.map(([roleKey, roleValue]) => (
                            <NavBar.SubMenuItem
                                key={roleKey}
                                id={roleKey}
                                isShowInNewTab={false}
                                url={endpoints.HEADER_ROLES_LINK.processReplacements({
                                    encryptedRoleName: roles[roleKey],
                                })}
                                render={() => (
                                    <Fragment>
                                        <a
                                            data-automation-id={roleKey}
                                            target={'_self'}
                                            rel="noopener noreferrer"
                                            title={intl.formatMessage({ id: 'common.link.title.newTab' })}
                                            onClick={() => handleChangeRole(roleKey)}
                                        >
                                            {roleValue === activeRoleLabel && (
                                                <FontAwesomeIcon icon="check" data-automation-id={`icon${roleKey}`} />
                                            )}
                                            &nbsp;
                                            {roleKey === role && (
                                                <FontAwesomeIcon icon="key" data-automation-id={`icon${roleKey}`} />
                                            )}
                                            &nbsp;
                                            <span>{roleValue}</span>
                                        </a>
                                    </Fragment>
                                )}
                            />
                        ))}
                    </NavBar.Menu>
                    <span className="additional-content">)</span>
                </NavBar.Item>
            </NavBar>
        );
    };

    return { TopNavMenuComponent, activeRoleLabel, handleChangeRole };
};
